import { render } from "./TalkToMeAbout.vue?vue&type=template&id=f74cd9c4&scoped=true"
import script from "./TalkToMeAbout.vue?vue&type=script&lang=js"
export * from "./TalkToMeAbout.vue?vue&type=script&lang=js"

import "./TalkToMeAbout.vue?vue&type=style&index=0&id=f74cd9c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f74cd9c4"]])

export default __exports__